import React, { Fragment, useState, useEffect } from 'react'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCertificate,
    faCopyright,
    faPlus,
} from '@fortawesome/free-solid-svg-icons'

// router
import { withRouter } from 'react-router-dom'

// formik
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Select from 'react-select'

// services
import { saveError } from '../../Services/errorService'
import { saveDatoFiscal } from '../../Services/datoFiscalService'

// components
import Swal from 'sweetalert2'
import Header from '../Header/Header'
import { getAllCondicionesFiscales } from '../../Services/condicionFiscal'
import useBackofficeListsForTenant from './hooks/useBackofficeListsForTenant'
import useMagentaTenantGuard from './hooks/useMagentaTenantGuard'

function AddDatoFiscal({ history, location }) {
    const { tenantId, tenantNombre } = useMagentaTenantGuard(history, location)
    const { sucursales, puntoVentas, loading: loadingBackoffice } =
        useBackofficeListsForTenant(tenantId)

    const [condicionesFiscales, setCondicionesFiscales] = useState([])

    const formik = useFormik({
        initialValues: {
            razonSocial: '',
            domicilioFiscal: '',
            condicionFiscal: {},
            cuitCuil: '',
            apiKey: '',
        },
        validationSchema: Yup.object({
            razonSocial: Yup.string().required('La razon social es requerida'),
            domicilioFiscal: Yup.string(),
            condicionFiscal: Yup.object().required(
                'La condicion fiscal es requerida'
            ),
            cuitCuil: Yup.string().required('El CUIT/CUIL es requerido'),
            apiKey: Yup.string(),
        }),
        onSubmit: (values) => addDatoFiscal(values),
    })

    useEffect(() => {
        const input = document.getElementById('inputRazonSocial')
        if (input) input.focus()
        getAllCondicionesFiscales()
            .then((res) => setCondicionesFiscales(res.data))
            .catch((err) => console.log('error'))
    }, [])

    const addDatoFiscal = (values) => {
        let datoFiscal = {
            ...values,
            condicionFiscalId: values.condicionFiscal.id,
            tenantId,
        }

        console.log(datoFiscal, values)

        saveDatoFiscal(datoFiscal)
            .then(() => {
                history.goBack()
            })
            .catch(async (error) => {
                const errorData = {
                    mensaje: 'Error al intentar crear un dato fiscal',
                    detalle: error.message,
                    entidad: 'DATO_FISCAL',
                    tipo: 'WEBAPP',
                    severidad: 'HIGH',
                    reportado: 'APPLICATION',
                }

                await saveError(errorData)
                Swal.fire({
                    text: 'Error al crear el dato fiscal, verifique los datos.',
                    type: 'error',
                    showConfirmButton: false,
                    timer: 2500,
                })
                console.error(error)
            })
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faCertificate}
                        title={
                            tenantNombre
                                ? `Dato Fiscal — ${tenantNombre}`
                                : 'Dato Fiscal'
                        }
                    />
                </div>

                <div className="bg-gris p-4">
                    {!loadingBackoffice ? (
                        <p className="text-muted small mb-3">
                            Recursos actuales del tenant: {sucursales.length}{' '}
                            sucursales, {puntoVentas.length} puntos de venta.
                        </p>
                    ) : null}
                    <form onSubmit={formik.handleSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputRazonSocial">
                                    Razon Social
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCopyright} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputRazonSocial"
                                        name="razonSocial"
                                        className="form-control"
                                        placeholder="Ej. MAGENTA SRL"
                                        value={formik.values.razonSocial}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.razonSocial &&
                                formik.errors.razonSocial ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.razonSocial}
                                    </small>
                                ) : null}
                            </div>
                            <div className="form-group col-md-4">
                                <label htmlFor="inputDomicilioFiscal">
                                    Domicilio Fiscal
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCopyright} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputDomicilioFiscal"
                                        name="domicilioFiscal"
                                        className="form-control"
                                        placeholder="Ej. Av Mate de Luna 3000"
                                        value={formik.values.domicilioFiscal}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.domicilioFiscal &&
                                formik.errors.domicilioFiscal ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.domicilioFiscal}
                                    </small>
                                ) : null}
                            </div>
                            <div className="form-group col-md-4">
                                <label htmlFor="inputCuitCuil">
                                    CUIT / CUIL
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCopyright} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputCuitCuil"
                                        name="cuitCuil"
                                        className="form-control"
                                        placeholder="2012345661"
                                        value={formik.values.cuitCuil}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.cuitCuil &&
                                formik.errors.cuitCuil ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.cuitCuil}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputCondicionFiscal">
                                    Conficion Fiscal
                                </label>
                                <div>
                                    <Select
                                        placeholder={
                                            'Seleccionar una condicion fiscal'
                                        }
                                        options={condicionesFiscales}
                                        onChange={(value) =>
                                            formik.setFieldValue(
                                                'condicionFiscal',
                                                value
                                            )
                                        }
                                        getOptionValue={(values) => values.id}
                                        getOptionLabel={(values) =>
                                            values.nombre
                                        }
                                    ></Select>
                                </div>
                                {formik.touched.conficionFiscal &&
                                formik.errors.conficionFiscal ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.conficionFiscal}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputApiKey">Api Key</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCopyright} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputApiKey"
                                        name="apiKey"
                                        className="form-control"
                                        placeholder="api key afip"
                                        value={formik.values.apiKey}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.apiKey &&
                                formik.errors.apiKey ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.apiKey}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Crear Dato
                                Fiscal
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}
export default withRouter(AddDatoFiscal)
